export default __webpack_public_path__ + "static/prepaid-cards-solution-08ab74297cabdca1f81a4c8ef71da2d4.png";